var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-cell-group",
    { staticClass: "UPassword" },
    [
      _c("van-field", {
        staticClass: "inputBar",
        attrs: {
          "label-class": "textBar",
          type: "password",
          label: "新密码",
          placeholder: "请输入新密码",
          required: ""
        },
        model: {
          value: _vm.onePassword,
          callback: function($$v) {
            _vm.onePassword = $$v
          },
          expression: "onePassword"
        }
      }),
      _vm._v(" "),
      _c("van-field", {
        staticClass: "inputBar",
        attrs: {
          "label-class": "textBar",
          type: "password",
          label: "确认密码",
          placeholder: "请输入确认密码",
          required: "",
          "error-message": _vm.PwdValidateText,
          blur: _vm.PwdValidate
        },
        model: {
          value: _vm.twoPassword,
          callback: function($$v) {
            _vm.twoPassword = $$v
          },
          expression: "twoPassword"
        }
      }),
      _vm._v(" "),
      _c(
        "van-col",
        {
          staticClass: "barBtn",
          attrs: { span: "24", type: "flex", justify: "space-between" }
        },
        [
          _c(
            "van-button",
            {
              staticClass: "saveBth",
              attrs: { round: "", type: "danger", size: "large" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.UpdatePwd($event)
                }
              }
            },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be0e5dc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be0e5dc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Settings/UpdatePassword.vue
// module id = null
// module chunks = 